export default __webpack_public_path__ + "static/media/community-influncer_Scott-Brinker.951e5b1b.jpeg";